import React, { Fragment } from 'react';
import axios from 'axios';
import Comment from './Comment';
import CommentsForm from './CommentsForm';
import Reactions from './../Partials/Reactions';
import CommentDummy from './../Dummies/CommentDummy';
import SocialShare from '../PostComponents/SocialShare';

class Comments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ordering: 'newest',
            comments: [],
            isLoading: false,
            total: 0,
            totalWithReplies: 0,
            currentPage: 1,
            nextPageUrl: '',
            to: 0,
            replyToComment: new URLSearchParams(window.location.search).get("replytocom"),
            showComments: new URLSearchParams(window.location.search).get("replytocom") || props.showComments
        }

        this.onChangeValue = this.onChangeValue.bind(this);
        this.fetchComments = this.fetchComments.bind(this);
        this.fetchMoreComments = this.fetchMoreComments.bind(this);
    }

    componentDidMount() {
        this.fetchComments();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.showComments !== this.props.showComments){
            this.setState({          
                showComments: this.props.showComments
            });
        }
    }

    fetchComments(ordering = 'newest') {
        // Set ordering to newest as default
        let orderBy = 'created_at';
        let orderDirection = 'DESC';

        switch (ordering) {
            case 'oldest':
                orderBy = 'created_at';
                orderDirection = 'ASC';
                break;
        
            default:
                break;
        }

        this.setState({
            isLoading: true,
            comments: [],
        });

        axios.get(`/api/comment/?commentable_id=${this.props.post.id}&orderby=${orderBy}&direction=${orderDirection}&count=${this.props.post.meta_data.comment_count}`)
        .then((response) => {
            this.setState(() => ({
                comments: response.data.data,
                isLoading: false,
                total: response.data.total,
                totalWithReplies: response.data.total_with_replies,
                currentPage: response.data.current_page,
                nextPageUrl: response.data.next_page_url,
                to: response.data.to,
            }));

            // Scroll to comments area (delay needed for element to be rendered first)
            if (this.state.replyToComment) {
                setTimeout(() => {
                    const form = document.getElementById(`comment_form_${this.props.post.id}_${this.state.replyToComment}`);
                    form.scrollIntoView({
                        behavior: "smooth",
                    });
                    const textArea = form.querySelector('[name="comment_body"]');
                    textArea.focus();
                },50);
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    fetchMoreComments() {
        this.setState({
            isLoading: true,
        });

        axios.get(this.state.nextPageUrl)
        .then((response) => {
            this.setState(() => ({
                comments: this.state.comments.concat(response.data.data),
                isLoading: false,
                currentPage: response.data.current_page,
                nextPageUrl: response.data.next_page_url,
                to: response.data.to,
            }));
        })
        .catch((error) => {
            console.log(error);
        });
    }

    onChangeValue(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        
        if (e.target.name == 'ordering') {
            this.fetchComments(e.target.value);
        }
    }

    render() {
        const postId = this.props.post.id;

        const commentsTitle = this.props.post.meta_data.comments_title || "Vad tycker du?";

        const comments = this.state.comments.map((comment) => (
            <Comment 
                key={comment.id} 
                post={this.props.post} 
                comment={comment} 
                onFetchComments={this.fetchComments} 
                showForm={this.state.replyToComment == comment.id} 
            />
        ));

        const commentsBtnText = comments.length == 0 ? "Kommentera här" : `${this.state.totalWithReplies} kommentarer`;

        return (
            <div className="comments">
                <div className={`comments__top ${this.props.post.meta_data.single_reaction == 1 ? ` comments__top--stretch` : ``}`}>
                    {
                      this.props.post.meta_data.hide_comments != "1" && 
                      this.props.post.meta_data.activate_comments_title == "1" &&
                      <p>{commentsTitle}</p>
                    }
                    <Reactions post={this.props.post} />
                    {this.props.post.meta_data.hide_comments != "1" && 
                    !this.state.showComments && 
                        <button className="btn btn-primary toggle-hide" onClick={this.props.onShowComments}>{commentsBtnText}</button>
                    }
                </div>
                <span id={`post-${this.props.post.id}-comments`} className="anchor" />
                {this.props.post.meta_data.hide_comments != "1" &&  this.state.showComments && 
                    <div id={`comments_area_${postId}`}>
                        <CommentsForm post={this.props.post} onFetchComments={this.fetchComments} />
                        <p className="comments__legal">
                            Din kommentar inväntar granskning innan den publiceras. Du som kommenterar ansvarar själv för innehållet i kommentaren. Ansvarig utgivare för denna webbplats har inte något ansvar för kommentarerna. Aller media uppmanar kommentatorer att använda vänlig ton, ett civiliserat språk, uppföra sig väl och följa tillämpliga lagar.
                        </p>
                        <div className="comments__list">
                            {comments.length > 0 &&
                            <div className="comments__list__controls d-flex">
                                <select name="ordering" className="form-control" onChange={this.onChangeValue} value={this.state.ordering}>
                                    <option value="newest">Nyast först</option>
                                    <option value="oldest">Äldsta först</option>
                                </select>
                            </div>
                            }
                            { comments.length > 0 && comments }
                            { this.state.isLoading && 
                                <React.Fragment>
                                    <CommentDummy />
                                    <CommentDummy>
                                        <CommentDummy />
                                    </CommentDummy>
                                    <CommentDummy />
                                </React.Fragment>
                            }
                            { !this.state.isLoading && this.state.to < this.state.total && 
                                <div className="comments__more">
                                    <button className="btn btn-primary" onClick={this.fetchMoreComments}>Ladda fler kommentarer</button>
                                </div>
                            }
                        </div>
                    </div>
                }
                <SocialShare post={this.props.post} />
            </div>
        )
    }
}

export default Comments;